import { ICourse } from 'interfaces/courses';
import { Show } from '@refinedev/antd';
import { Typography } from 'antd';
import { useShow } from '@refinedev/core';

const { Title, Text } = Typography;

export const CourseShow = () => {
  const { queryResult } = useShow<ICourse>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading} title="Visualizar curso avulso">
      <Title level={5}>ID</Title>
      <Text>{record?.id}</Text>
      <Title level={5}>Nome</Title>
      <Text>{record?.name}</Text>
      <Title level={5}>Duração (horas)</Title>
      <Text>{record?.duration_in_hours}</Text>
    </Show>
  );
};
